import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { Content } from '@xanadu/model';
import { PickerComponent } from '../picker/picker.component';
import { ContentService } from '@xanadu/service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-content-picker',
    templateUrl: './content-picker.component.html',
    styleUrls: ['./content-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContentPickerComponent extends PickerComponent<Content> {
    private readonly contentService = inject(ContentService);

    constructor() {
        super();

        effect(() => {
            const meta = this.meta();

            if (meta?.typeId) {
                void firstValueFrom(this.contentService.pick(meta.typeId))
                    .then(result => {
                        this.items.set(result);
                    });
            }
        });
    }

    protected filter(content: Content): boolean {
        const meta = this.meta();

        if (meta?.prototypes) {
            return !!content?.prototype && meta.prototypes.includes(content.prototype._id);
        }
        return true;
    }
}
